import { useState, useEffect } from 'react'

// 컨텐츠 관리 탭(SqlConverter / SqlConverterWorkbench / Semantic View / Composite View)
// 에서 항목을 같은 본문으로 복제할 때 사용하는 공용 모달 다이얼로그.
//
// - 자동 제안 이름은 props.defaultName 으로 받고, 사용자가 다이얼로그에서 편집할 수 있다.
// - Enter 키로 즉시 확정, ESC / 바깥 클릭 / 취소 버튼으로 취소.
// - 마크업/스타일은 Explore.jsx 의 'copy-to-workspace' 다이얼로그와 동일 클래스
//   (.explore-copy-overlay / .explore-copy-dialog) 를 그대로 재사용해 디자인 일관성을 유지한다.
export default function DuplicateDialog({
  open,
  defaultName,
  onConfirm,
  onCancel,
  busy = false,
  title = '복제',
  hint = '내 워크스페이스에 같은 내용으로 새 항목을 만듭니다.',
  confirmLabel = '복제',
  busyLabel = '복제 중...',
  nameLabel = '새 이름',
}) {
  const [name, setName] = useState(defaultName || '')

  // open 또는 defaultName 이 바뀌면 입력값을 새 제안 이름으로 초기화
  useEffect(() => {
    if (open) setName(defaultName || '')
  }, [open, defaultName])

  if (!open) return null

  const trimmed = name.trim()
  const canConfirm = !busy && !!trimmed

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && canConfirm) {
      e.preventDefault()
      onConfirm(trimmed)
    } else if (e.key === 'Escape') {
      e.preventDefault()
      if (!busy) onCancel()
    }
  }

  return (
    <div className="explore-copy-overlay" onClick={() => !busy && onCancel()}>
      <div className="explore-copy-dialog" onClick={e => e.stopPropagation()}>
        <h3>{title}</h3>
        <div className="form-group">
          <label>{nameLabel}</label>
          <input
            className="field"
            value={name}
            onChange={e => setName(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
          />
          <div className="form-hint">{hint}</div>
        </div>
        <div className="explore-copy-actions">
          <button className="btn-secondary" onClick={onCancel} disabled={busy}>취소</button>
          <button className="btn-primary" onClick={() => onConfirm(trimmed)} disabled={!canConfirm}>
            {busy ? busyLabel : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
